/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConfigurationViews } from './ConfigurationViews';
import {
    ConfigurationViewsFromJSON,
    ConfigurationViewsFromJSONTyped,
    ConfigurationViewsToJSON,
} from './ConfigurationViews';

/**
 * Configuration for client management
 * @export
 * @interface ClientManagementConfiguration
 */
export interface ClientManagementConfiguration {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementConfiguration
     */
    accountRID: string;
    /**
     * 
     * @type {number}
     * @memberof ClientManagementConfiguration
     */
    version: number;
    /**
     * 
     * @type {ConfigurationViews}
     * @memberof ClientManagementConfiguration
     */
    configurationViews?: ConfigurationViews;
    /**
     * Enable or disable a pilot mode for client management
     * @type {boolean}
     * @memberof ClientManagementConfiguration
     */
    pilotMode?: boolean;
    /**
     * User Id's for those who should be able to interact with Client Management in pilot mode.
     * @type {Array<string>}
     * @memberof ClientManagementConfiguration
     */
    pilotModeUserIds?: Array<string>;
}

/**
 * Check if a given object implements the ClientManagementConfiguration interface.
 */
export function instanceOfClientManagementConfiguration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accountRID" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function ClientManagementConfigurationFromJSON(json: any): ClientManagementConfiguration {
    return ClientManagementConfigurationFromJSONTyped(json, false);
}

export function ClientManagementConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientManagementConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountRID': json['accountRID'],
        'version': json['version'],
        'configurationViews': !exists(json, 'ConfigurationViews') ? undefined : ConfigurationViewsFromJSON(json['ConfigurationViews']),
        'pilotMode': !exists(json, 'pilotMode') ? undefined : json['pilotMode'],
        'pilotModeUserIds': !exists(json, 'pilotModeUserIds') ? undefined : json['pilotModeUserIds'],
    };
}

export function ClientManagementConfigurationToJSON(value?: ClientManagementConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountRID': value.accountRID,
        'version': value.version,
        'ConfigurationViews': ConfigurationViewsToJSON(value.configurationViews),
        'pilotMode': value.pilotMode,
        'pilotModeUserIds': value.pilotModeUserIds,
    };
}

